// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

  const firebaseConfig = {
    apiKey: "AIzaSyB0eKonHleJCDnd1lNy0ufP67GDIfJD-TU",
  authDomain: "barq-fcde6.firebaseapp.com",
  projectId: "barq-fcde6",
  storageBucket: "barq-fcde6.firebasestorage.app",
  messagingSenderId: "483231636730",
  appId: "1:483231636730:web:95d9d08e884eb11755fd43",
  measurementId: "G-3506GKKHTM"
  };


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);


export const requestPermisson = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:   "BAN6AcVVpklTDLoA_RYXsNvW48q0JxaKkm8lQ7qvtGI_HHzH_0-Ycuz4_NHe5WvNPm5Ft0upFi24NbbhYuD867s",
      });
      if (token) {
        console.log("Token available:", token);
        return token;
      } else {
        console.error("No token received.");
        return null;
      }
    } else {
      console.log("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting permission:", error);
  }
};
requestPermisson()

export { messaging };
